<template>
  <div class="summary-tickets">
    <DateFilter :with-market-id="true" @submit="search" />

    <div v-if="dateText.start===dateText.end">ข้อมูลวันที่ <span class="text-primary">{{dateText.start}}</span></div>
    <div v-else>
      ข้อมูลรวม <span class="text-primary">{{totalDay}}</span> วัน
      ตั้งแต่วันที่ <span class="text-primary">{{dateText.start}}</span>
      <span> ถึง
        <span class="text-primary">{{dateText.end}}</span>
      </span>
    </div>

    <ol v-if="roundId" class="breadcrumb px-2 py-1 mt-3 mb-0 alert-warning border-warning mb-1">
      <li class="breadcrumb-item">
        <a href="#" @click="toggleRound(null)"><i class="fas fa-angle-left"></i> กลับ</a>
      </li>
      <li class="breadcrumb-item">
        {{roundName}}
      </li>
    </ol>

    <div class="tickets-table position-relative">

      <table class="table table-sm table-bordered table-hover table-info mb-0">
        <thead>
          <tr>
            <th width="80">เลขที่</th>
            <th width="20%">หวย</th>
            <th width="15%">งวด</th>
            <th width="10%">ยอด</th>
            <th width="10%">ส่วนลด</th>
            <th width="10%">ถูกรางวัล</th>
            <th width="10%">แพ้/ชนะ</th>
            <th>หมายเหตุ</th>
            <th width="50">ดูโพย</th>
          </tr>
        </thead>
        <tbody v-if="roundId">
          <tr v-for="item in items" :key="item._id">
            <td>{{item.ticketNo}}</td>
            <td>{{item.market.marketTitle}}</td>
            <td class="text-center">{{item.round.roundDate}}</td>
            <td class="text-right text-info">{{ item.summary.amount | amountFormat(2, '0.00') }}</td>
            <td class="text-right text-danger">{{ item.summary.discount | amountFormat(2, '0.00') }}</td>
            <td class="text-right">
              <span v-if="item.isWon" class="text-success">{{ item.summary.won | amountFormat(2, '0.00') }}</span>
            </td>
            <td class="text-right" :class="[{'text-danger':item.winloss<0, 'text-success':item.winloss>0}]">
              {{ item.winloss | amountFormat(2, '0.00') }}
            </td>
            <td class="text-center">{{ item.remarks }}</td>
            <td class="text-center"><button class="btn btn-outline-info btn-sm" @click="toggleTicket(item._id)"><i class="fas fa-list"></i></button></td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="group in groups" :key="group[0]._id">
            <td colspan="2">{{group[0].market.marketTitle}}</td>
            <td class="text-center">
              <a href="#" @click="toggleRound(group[0].round.roundId)">{{group[0].round.roundDate}}</a>
            </td>
            <td class="text-right text-info">{{ groupAmount[group[0].round.roundId].amount | amountFormat(2) }}</td>
            <td class="text-right text-danger">{{ groupAmount[group[0].round.roundId].discount | amountFormat(2) }}</td>
            <td class="text-right text-success">{{ groupAmount[group[0].round.roundId].won | amountFormat(2) }}</td>
            <td class="text-right"
              :class="[{
                'text-danger':groupAmount[group[0].round.roundId].winloss < 0
              }, {
                'text-success':groupAmount[group[0].round.roundId].winloss > 0
              }]">{{ groupAmount[group[0].round.roundId].winloss | amountFormat(2) }}</td>
            <td colspan="2" class="text-center"></td>
          </tr>
          <tr v-if="groups.length===0 && !isLoading">
            <td colspan="9" class="text-center">ไม่มีข้อมูล</td>
          </tr>
        </tbody>
        <tfoot v-if="groups.length > 0">
          <tr v-if="roundId">
            <th colspan="3" class="text-center">รวม</th>
            <th class="text-right text-info">{{ itemSummary.amount | amountFormat(2) }}</th>
            <th class="text-right text-danger">{{ itemSummary.discount | amountFormat(2) }}</th>
            <th class="text-right text-success">{{ itemSummary.won | amountFormat(2) }}</th>
            <th class="text-right"
              :class="[{
                'text-danger':itemSummary.winloss < 0
              }, {
                'text-success':itemSummary.winloss > 0
              }]"
            >{{ itemSummary.winloss | amountFormat(2) }}</th>
            <th colspan="2" class="text-right"></th>
          </tr>
          <tr v-else>
            <th colspan="3" class="text-center">รวม</th>
            <th class="text-right text-info">{{ groupSummary.amount | amountFormat(2) }}</th>
            <th class="text-right text-danger">{{ groupSummary.discount | amountFormat(2) }}</th>
            <th class="text-right text-success">{{ groupSummary.won | amountFormat(2) }}</th>
            <th class="text-right"
              :class="[{
                'text-danger':groupSummary.winloss < 0
              }, {
                'text-success':groupSummary.winloss > 0
              }]"
            >{{ groupSummary.winloss | amountFormat(2) }}</th>
            <th colspan="2" class="text-right"></th>
          </tr>
        </tfoot>
      </table>

      <loading
        :active="isLoading"
        :can-cancel="false"
        :is-full-page="false"
        background-color="#EBEDEF"
        :height="30"
        :width="30"
        color="#007bff"
      />
    </div>

    <ViewTicketModal :is-show="isShowTicketModal" :ticket-id="viewTicketId" @close="isShowTicketModal=false" />
  </div>
</template>
<script>
import DateFilter from '@/views/report/components/DateFilter'
import ReportService from '@/services/ReportService'
import Swal from 'sweetalert2'
import moment from '@/helpers/moment'
import _ from 'lodash'
import ViewTicketModal from '@/views/report/components/ViewTicketModal'
import cAlert from '@/helpers/alert'

export default {
  name: 'Summary',
  components: {
    DateFilter,
    ViewTicketModal
  },
  data() {
    return {
      data: null,
      isLoading: false,
      filters: {
        startDate: null,
        endDate: null,
        marketIds: []
      },
      roundId: null,
      isShowTicketModal: false,
      viewTicketId: null
    }
  },
  computed: {
    roundName() {
      if(!this.roundId)
        return ''

      return `${this.items[0].market.marketTitle} - ${this.items[0].round.roundDate}`
    },
    groups() {
      if(!this.data)
        return []

      const groups = _.groupBy(this.data.items, (item)=>{
        if(!this.roundId)
          return item.round.roundId

        return item._id
      })

      return Object.keys(groups).map((roundId)=>{
        return groups[roundId]
      })
    },
    groupAmount() {
      return this.groups.reduce((groups, tickets)=>{
        groups[tickets[0].round.roundId] = tickets.reduce((summary, ticket)=>{
          summary.amount += (ticket?.summary?.amount || 0)
          summary.credit += (ticket?.summary?.credit || 0)
          summary.discount += (ticket?.summary?.discount || 0)
          summary.winloss += (-ticket?.summary?.credit || 0)
          if(ticket.isWon) {
            summary.won += (ticket?.summary?.won || 0)
            summary.winloss += (ticket.summary.won || 0)
          }
          return summary
        }, {
          amount: 0,
          credit: 0,
          discount: 0,
          won: 0,
          winloss: 0
        })
        return groups
      }, {})
    },
    groupSummary() {
      return Object.keys(this.groupAmount).map((roundId)=>{
        return this.groupAmount[roundId]
      })
      .reduce((sum, group)=>{
        sum.amount += group.amount
        sum.credit += group.credit
        sum.discount += group.discount
        sum.won += group.won
        sum.winloss += group.winloss
        return sum
      }, {
        amount: 0,
        credit: 0,
        discount: 0,
        won: 0,
        winloss: 0
      })
    },
    items() {
      if(!this.data)
        return []

      const items = this.data.items.filter((item)=>{
        return item.round.roundId === this.roundId
      })

      return items.map((item)=>{
        if(item.isWon) {
          item.winloss = ((item?.summary?.won||0) - (item?.summary?.credit||0))
        }else{
          item.winloss = -(item?.summary?.credit||0)
        }

        item.summary = {
          amount: 0,
          credit: 0,
          discount: 0,
          length: 0,
          won: 0,
          ...item.summary
        }
        return item
      })
    },
    itemSummary() {
      return this.items.reduce((summary, item)=>{
        summary.amount += (item?.summary?.amount || 0)
        summary.credit -= (item?.summary?.credit || 0)
        summary.discount += (item?.summary?.discount || 0)
        summary.winloss += (-item?.summary?.credit || 0)
        if(item.isWon) {
          summary.won += (item?.summary?.won || 0)
          summary.winloss += (item?.summary?.won || 0)
        }
        return summary
      }, {
        amount: 0,
        credit: 0,
        discount: 0,
        won: 0,
        winloss: 0
      })
    },
    dateText() {
      if(!this.data)
        return {
          start: null,
          end: null
        }

      return {
        start: moment(this.data.filters.startDate).add(543, 'y').format('D MMMM YYYY'),
        end: moment(this.data.filters.endDate).add(543, 'y').format('D MMMM YYYY')
      }
    },
    totalDay() {
      if(!this.data)
        return ''

      return this.data.filters.total || 0
    }
  },
  methods: {
    search(filters) {
      this.filters = {
        ...filters,
        startDate: filters.date.start,
        endDate: filters.date.end,
        marketIds: filters.marketIds
      }
      this.loadTickets()
    },
    loadTickets() {
      this.isLoading = true
      ReportService.getTicketWithLottoIds('completed', this.filters).then((response)=>{
        if(response.success) {
          this.data = response.data
        }else{
          throw new Error(response?.message)
        }
      })
      .catch((e)=>{
        cAlert({
          ...e,
          title: 'ผิดพลาด!',
          text: e?.message || 'โหลดรายงานไม่สำเร็จ',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      })
      .finally(()=>{
        this.isLoading = false
      })
    },
    toggleRound(roundId) {
      this.roundId = roundId
    },
    toggleTicket(ticketId) {
      this.isShowTicketModal = true
      this.viewTicketId = ticketId
    }
  }
}
</script>
<style lang="scss" scoped>
.summary-tickets {
  padding-bottom: 50px;

  .tickets-table {
    background-color: #FFF;
    min-height: 50px;

    table {
      thead {
        tr {
          th {
            font-size: 85%;
            vertical-align: middle;
            text-align: center;
          }
        }
      }
      tbody {
        background-color: #FFF;
        tr {
          td {
            vertical-align: middle;
            font-size: 85%;
          }
        }
      }
    }
  }
}
</style>
